var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLessThanIcon = function SvgLessThanIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.844 0 0 114.839 0 256s114.844 256 256 256 256-114.839 256-256S397.156 0 256 0zm65.873 388.312c-3.219 4.848-8.523 7.469-13.927 7.469-3.175 0-6.381-.897-9.219-2.783L113.175 269.916a16.697 16.697 0 0 1 0-27.832l185.551-123.081c7.665-5.082 18.036-3.017 23.146 4.686 5.099 7.686 3 18.047-4.686 23.146L152.619 256l164.568 109.165c7.686 5.099 9.785 15.461 4.686 23.147z"
  })));
};

export default SvgLessThanIcon;